//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
// import { withStyles } from '@material-ui/core/styles';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { getYearsOfExperienceOptions } from '../lovHelper';
import { PLACEHOLDER_FIELD_YEARS_OF_EXPERIENCE } from '../placeholderHelper';
import AfitdAutocompleteLite from './AfitdAutocompleteLite';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _find from 'lodash/find';
// import _remove from 'lodash/remove';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
// const useStyles = makeStyles(theme => ({
// }));

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const options = getYearsOfExperienceOptions();

const getOptionLabel = option => {
    const selectedOption = typeof option === 'number' ? _find(options, o => o.minVal === option) : option;
    return selectedOption?.description;
};

const renderOption = (option, { selected }) => {
    return option.description;
};

const getOptionSelected = (option, value) => {
    return typeof value === 'number' ? option.minVal === value : option.minVal === value?.minVal;
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const AfitdYearsOfExperienceAutocomplete = props => {
    const { ...otherProps } = props;

    return (
        <AfitdAutocompleteLite
            placeholder={PLACEHOLDER_FIELD_YEARS_OF_EXPERIENCE}
            {...otherProps}
            options={options}
            getOptionLabel={getOptionLabel}
            renderOption={renderOption}
            getOptionSelected={getOptionSelected}
        />
    );
};

export default AfitdYearsOfExperienceAutocomplete;
